import { FormHandler } from './FormHandler';

window.addEventListener('DOMContentLoaded', initializeForms);

function initializeForms() {
  const formComponents = document.querySelectorAll('.wp-block-cobp-form');

  formComponents.forEach((component) => {
    new FormHandler(component);
  });
}
